import { AnalysisItem } from "helpers/models";

export default (
  analysisItems: AnalysisItem[]
): Record<string, Record<string, AnalysisItem[]>> => {
  return analysisItems.reduce((acc, item) => {
    const { layerId, valueLabel } = item;

    if (!acc[layerId]) {
      acc[layerId] = {};
    }

    if (!acc[layerId][valueLabel]) {
      acc[layerId][valueLabel] = [];
    }

    acc[layerId][valueLabel].push(item);

    return acc;
  }, {} as Record<string, Record<string, AnalysisItem[]>>);
};
